// extracted by mini-css-extract-plugin
export default {"item":"ButtonsHeader_item__UYxX6"};